import React, { useEffect, useState, useCallback } from 'react';
import { Helmet } from 'react-helmet';
import './About.css';

const AboutUsPage = () => {
  const [about, setAbout] = useState({ 
    title: '', 
    content: '', 
    image: '', 
    vision: '', 
    mission: '', 
    strategic_goals: '', 
    values: '', 
    org_structure: '', 
    work_fields: '' 
  });
  const [loading, setLoading] = useState(true);

  const fetchAbout = useCallback(async () => {
    setLoading(true);
  try {
  const res = await fetch(`${process.env.REACT_APP_API_URL || ''}/api/basic-info/about`);
      const data = await res.json();
      setAbout({
        title: data.title || 'من نحن',
        content: data.content || '',
        image: data.image || '',
        vision: data.vision || '',
        mission: data.mission || '',
        strategic_goals: data.strategic_goals || '',
        values: data.values || '',
        org_structure: data.org_structure || '',
        work_fields: data.work_fields || ''
      });
    } catch (error) {
      console.error('خطأ في جلب بيانات من نحن:', error);
      setAbout({
        title: 'من نحن',
        content: '',
        image: '',
        vision: '',
        mission: '',
        strategic_goals: '',
        values: '',
        org_structure: '',
        work_fields: ''
      });
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAbout();
  }, [fetchAbout]);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>جاري التحميل...</p>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>من نحن | منظمة جاستيس للحقوق والتنمية</title>
      </Helmet>
      
      <div className="about-page">
        {/* Hero Section */}
        <div className="about-hero">
          <div className="hero-content">
            <h1 className="hero-title">
              <span className="arabic-text">من نحن</span>
              <span className="english-text">About Us</span>
            </h1>
            <p className="hero-subtitle">
              <span className="arabic-text">منظمة جاستيس للحقوق والتنمية</span>
              <span className="english-text">Justice Organization for Rights and Development</span>
            </p>
          </div>
          <div className="hero-image">
            {about.image && (
              <img src={about.image} alt="من نحن" />
            )}
          </div>
        </div>

        {/* Main Content */}
        <div className="about-container">
          {/* About Us Section */}
          <section className="about-section">
            <div className="section-header">
              <h2 className="section-title">
                <span className="arabic-text">من نحن</span>
                <span className="english-text">Who We Are</span>
              </h2>
              <div className="title-underline"></div>
            </div>
            <div className="content-card">
            <div 
              className="content-text" 
              dangerouslySetInnerHTML={{ 
                __html: about.content || 
                'نحن منظمة مدنية غير ربحية، مستقلة، تُعنى بالدفاع عن الحقوق والحريات، وتعزيز مبادئ العدالة، وسيادة القانون، والتنمية المستدامة.<br />انطلقت منظمة "جاستيس للحقوق والتنمية" من إيمان راسخ بأن تحقيق العدالة وتمكين الإنسان هما الركيزتان الأساسيتان لأي مجتمع ناهض.<br />وقد تأسست المنظمة استجابةً لحاجة ملحّة لجهة حقوقية وتنموية تجمع بين العمل الحقوقي والتنموي في آنٍ واحد، وفق معايير مهنية وشفافة.' 
              }} 
            />
            </div>
          </section>

          {/* Vision Section */}
          <section className="about-section">
            <div className="section-header">
              <h2 className="section-title">
                <span className="arabic-text">الرؤية</span>
                <span className="english-text">Vision</span>
              </h2>
              <div className="title-underline"></div>
            </div>
            <div className="content-card vision-card">
              <div className="card-icon">👁️</div>
              <div className="content-text">{about.vision || 'الريادة محلياً ودولياً في حماية الحقوق وتمكين المجتمعات من الوصول إلى العدالة والتنمية المستدامة '}</div>
            </div>
          </section>

          {/* Mission Section */}
          <section className="about-section">
            <div className="section-header">
              <h2 className="section-title">
                <span className="arabic-text">الرسالة</span>
                <span className="english-text">Mission</span>
              </h2>
              <div className="title-underline"></div>
            </div>
            <div className="content-card mission-card">
              <div className="card-icon">🎯</div>
              <div className="content-text">{about.mission || 'تعزيز سيادة القانون وحماية الحقوق والحريات والمساهمة في تحقيق التنمية من خلال التوعية القانونية وبناء القدرات والدفاع عن الفئات المهمشة ، ورصد الانتهاكات العدالة الشاملة  بالشراكة مع الجهات الفاعلة محلياً ودولياً'}</div>
            </div>
          </section>

          {/* Strategic Goals Section */}
          <section className="about-section">
            <div className="section-header">
              <h2 className="section-title">
                <span className="arabic-text">أهدافنا</span>
                <span className="english-text"> Our Objectives </span>
              </h2>
              <div className="title-underline"></div>
            </div>
            <div className="content-card goals-card">
              <div className="card-icon">🎯</div>
                                  <div 
                                    className="content-text" 
                                    dangerouslySetInnerHTML={{ 
                                      __html: about.content || 
                                      `
                                        <p>
                                          تعزيز نظام الحكومة وسيادة القانون والحكم الرشيد واحترام حقوق الإنسان من خلال نشر الوعي القانوني في المجتمع بمختلف قطاعاته، مع التركيز على الجهات العاملة في إنفاذ القانون والمؤسسات القضائية، بما يعزز من احترام الحقوق والحريات العامة.
                                        </p>
                                        <ul>
                                          <li>المساهمة في تسهيل فهم القوانين والحقوق الدستورية من خلال برامج تعليمية ومحتويات تثقيفية باستخدام وسائط حديثة تتناسب مختلف الفئات العمرية في المجتمع.</li>
                                          <li>المساهمة في رفع كفاءة وقدرات العاملين في مؤسسات إنفاذ القانون والقضاء من خلال برامج نوعية متخصصة تدمج بين الجوانب القانونية والمعايير الحقوقية الوطنية والدولية ومبادئ الحوكمة.</li>
                                          <li>العمل على تمكين الفئات المهمشة من الوصول العادل إلى العدالة من خلال تقديم الدعم القانوني والاستشاري لهم وتذليل كافة العوائق التي تعيق قدرتهم على نيل حقوقهم وإنصافهم.</li>
                                          <li>رصد وتوثيق الانتهاكات القانونية والحقوقية ومناصرة الضحايا.</li>
                                          <li>المساهمة في تعزيز الشفافية والمساءلة في إنفاذ التشريعات وتحديثها في مؤسسات إنفاذ القانون والقضاء من خلال الرقابة المجتمعية والإجراءات التي تضمن النزاهة والمساءلة.</li>
                                          <li>ترسيخ ثقافة الحوار وحل النزاعات بالوسائل السلمية من خلال تعزيز قيم التسامح، ونشر ممارسات الحلول السلمية للنزاعات، وتشجيع المجتمعات المحلية على تبني الحوار كوسيلة بديلة للعنف.</li>
                                          <li>المساهمة في دعم العدالة الانتقالية وبناء السلم الأهلي من خلال دعم جهود الإنصاف وجبر الضرر وتعزيز التماسك المجتمعي في مرحلة ما بعد النزاع.</li>
                                          <li>المساعدة على دمج مبادئ العدالة في السياسات والمشاريع التنموية من خلال العمل على تكامل الحقوق المدنية والسياسية والاقتصادية والاجتماعية ضمن مبادرات التنمية لضمان شمولها وعدالتها حتى في المناطق المتأثرة بالنزاع أو التهميش.</li>
                                          <li>بناء شراكات محلية ودولية فاعلة في مجال العدالة من خلال شبكات تعاون استراتيجية مع منظمات المجتمع المدني والمؤسسات الحقوقية، الحكومية والدولية بما يضمن تحقيق التنمية الشاملة والمستدامة في اليمن.</li>
                                        </ul>
                                      `
                                    }} 
                                  />
            </div>
          </section>

          {/* Values Section */}
          <section className="about-section">
            <div className="section-header">
              <h2 className="section-title">
                <span className="arabic-text"> قيمنا</span>
                <span className="english-text"> Our Values</span>
              </h2>
              <div className="title-underline"></div>
            </div>
            <div className="content-card values-card">
              <div className="card-icon">💎</div>
                <div 
                  className="content-text" 
                  dangerouslySetInnerHTML={{ 
                    __html: about.content || 
                    `
                      <ul>
                        <li>العدالة</li>
                        <li>الكرامة الإنسانية</li>
                        <li>الحياد والاستقلالية</li>
                        <li>الشفافية والمساءلة</li>
                        <li>التمكين والمناصرة</li>
                        <li>السلم والحوار</li>
                        <li>التنمية المستدامة</li>
                      </ul>
                    `
                  }} 
                />
            </div>
          </section>

 

       
        </div>
      </div>
    </>
  );
};

export default AboutUsPage; 